export default function formatDate(timestamp: number | string | Date): string {
  try {
    // Convert the input to a Date object
    const date = new Date(timestamp)

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'No date'
    }

    // Define an array of month names
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    // Format the date
    const day = date.getDate()
    const month = monthNames[date.getMonth()]
    const year = date.getFullYear()

    return `${day} ${month} ${year}`
  } catch (error) {
    // Return "No date" if any error occurs
    return 'No date'
  }
}
